import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { Subject } from "rxjs";
import { DescrittoreSezione } from "../common/models/descrittore-sezione";
import { inject } from "@angular/core";
import { HelpersService } from "../core/services/helpers.service";
import { UrlSettingsCore } from "../core/configuration/url-settings-core";
import { ModalNotifyService } from "../core/services/modal-notify.service";

export const authGuardGenDoc = (next: ActivatedRouteSnapshot) => {
  const helpersService: HelpersService = inject(HelpersService);
  const modalNotifyService: ModalNotifyService = inject(ModalNotifyService);
  const router: Router = inject(Router);
  let descrittori: DescrittoreSezione[] = [];
  let subject = new Subject<boolean>();
  if (descrittori.length === 0) {
    helpersService.getDescrittori().subscribe(res => {
      descrittori = res;
      return subject.next(checkDescrittori(res, next, modalNotifyService, router))
    })
  } else return checkDescrittori(descrittori, next, modalNotifyService, router);

  return subject.asObservable();
}

const checkDescrittori = (descrittori: DescrittoreSezione[], route: ActivatedRouteSnapshot, modalNotifyService: ModalNotifyService, router: Router) => {
  let checkDescrittore: boolean = false;

  //controllo prima il descrittore associato alla route
  if (route.data && route.data.descrittore) {
    let descrittore = route.data.descrittore;
    let descrittoreUser = descrittori.find(el => el.entitySimpleName === descrittore);
    if (descrittoreUser && (descrittoreUser.readable || descrittoreUser.writable)) {
      checkDescrittore = true;
    } else {
      allertMessage(false, modalNotifyService, router);
      return checkDescrittore = false;
    }
  } else checkDescrittore = true;
  return checkDescrittore
}

const allertMessage = (permesso: boolean, modalNotifyService: ModalNotifyService, router: Router) => {
  if (!permesso) {
    modalNotifyService.messaggioCustom('Permesso negato', 'Attenzione!');
    router.navigate([UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD]);
  }
}
